import React from 'react';

import { FocusRingBox } from '../styles';

interface Props {
  /** Posición del toque, relativa a la caja del visor. */
  x: number;
  y: number;
}

/**
 * Realimentación del enfoque al tocar. Solo se pinta cuando el dispositivo
 * acepta de verdad el punto de enfoque; si no, no se dibuja nada, para no
 * prometer un gesto que no tiene efecto.
 */
export const FocusRing = ({ x, y }: Props): JSX.Element => (
  <FocusRingBox $x={x} $y={y} aria-hidden="true" />
);
